import { hasAppFeature, web2app } from '@kcd/app-interface';
import { CellLinkAction } from '@kcd/design-system';

import {
  useCurrentUser,
  useCurrentUserPlusMembership,
} from '~/domains/auth/queries';
import { MY_POINT_URL } from '~/domains/point/constants';
import { usePointSearch } from '~/domains/point/queries';
import { openModal } from '~/utils/mobileApp';

import MembershipIcon from '~/assets/icons/ic__membership_standard__detail.svg';

export function UserInfo() {
  const { user } = useCurrentUser();
  const { data } = usePointSearch();
  const { data: membershipData } = useCurrentUserPlusMembership();

  const onPointClick = () => {
    if (hasAppFeature('openBenefitZone')) {
      web2app.openBenefitZone({
        referrer: 'cashnote_market',
      });
    } else {
      openModal({
        url: MY_POINT_URL,
      });
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div>
        {membershipData?.isPlusMembership && user?.businessName && (
          <p className="mb-2 flex items-center gap-4">
            <MembershipIcon />
            <span className="text-description typo-paragraph100-regular">
              {user?.businessName}
            </span>
          </p>
        )}
        <strong className="typo-heading100">{user?.name} 사장님</strong>
      </div>
      <button
        className="flex items-center text-accent typo-title100-semibold"
        onClick={onPointClick}
        type="button"
      >
        {(data?.totalPoint || 0).toLocaleString()}P
        <CellLinkAction className="!ml-0 [&>*>svg]:fill-blue-600" />
      </button>
    </div>
  );
}
